import { PaymentServiceProvider } from "@app/core/models/payment-service-models.model";

export class ManagePaymentRequest {    
    constructor() { }
    public brand: string;
    public expirationMonth: number;
    public expirationYear: number;
    public id: string;
    public name: string;
    public number: string;
    public zipCode: string;
    public isDefault: boolean;
    public paymentType: string | null;
    public isExpired: boolean;
    public isAutoReload: boolean;
    public paymentTokenOrId: string;
    public paypalAuthorizationCode: string;
    public hideCarot?: boolean | false;
    public saveForFuturePayment?: boolean | true;
    public token?: string | null;
    public tokenType?: number | null;
    public paymentCardType?: string |null ;
    public paymentServiceProvider?: PaymentServiceProvider | null;
    public dataCollectorSessionId?: string | null;
}
